
    import './styles.scoped.css';
    export default {
  "flash-header": "awsui_flash-header_4c95g_vov7p_5"
};
  